import { API, DesignerAPI, Endpoints, Form, FormAPI, MetricsAPI, ResponseType, TagsAPI } from '@brg/api';
import axios from 'axios';
import { RequestParentProps } from 'shared/components/CommentsController/const/types';
import { SUBSCRIBE_VISIBILITY_STATUS } from 'shared/components/Subscribe/const';
import { mergeArraysBySubscribedId } from 'shared/components/Subscribe/support';
import { FormFieldType } from 'shared/modals/ApplicationEditor/constants';
const GETAWAY_DEV = 'api.burgdev.ru';
const GETAWAY_STG = 'api.burgstg.ru';
const GETAWAY_PROD = 'api.mediiia.ru';

interface IGateway {
    [key: string]: string
}

const GATEWAY_ROUTE: IGateway = {
    'develop': GETAWAY_DEV,
    'staging': GETAWAY_STG,
    'production': GETAWAY_PROD
}

const legalsUrl = `https://${GATEWAY_ROUTE[process.env.REACT_APP_API_CONNECTION_MODE as keyof IGateway]}`
const cardUrl = Endpoints.cardsMnePw;

export const getGalllleryUrl = (isShop: boolean) => {
    const galleryUrls = {
        develop: 'https://gallllery-com.burgdev.ru',
        staging: 'https://gallllery-com.burgstg.ru',
        production: 'https://gallllery.com',
        hseOnline: 'https://gallllery.com'
    }

    const shopGalleryUrls = {
        develop: 'https://shop-artz-work.burgdev.ru',
        staging: 'https://shop-artz-work.burgstg.ru',
        production: 'https://shop.artz.work',
        hseOnline: 'https://shop.artz.work'
    }

    // @ts-ignore
    return (isShop ? shopGalleryUrls : galleryUrls)[process.env.REACT_APP_API_CONNECTION_MODE ?? 'develop'];
}

const urlSearchParamsToString = (params: any) => {
    const paramArray = [];
    //@ts-ignore
    for (const [key, value] of params.entries()) {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(value);
        paramArray.push(`${encodedKey}=${encodedValue}`);
    }

    if (paramArray.length === 0) {
        return '';
    }

    return `&${paramArray.join('&')}`;
}


export default function urlApi() {
    return {
        applyProjectToCompetition({ nominationId, projectId, makePrivate }: { nominationId: string, projectId: string, makePrivate?: boolean }) {
            const request = API.request()
                .endpoint(Endpoints.competitions)
                .url('/api/Competition/Apply')
                .post()
                .addQuery('NominationID', nominationId)
                .addQuery('ProjectID', projectId)
            if (makePrivate) {
                request.addQuery('hideProject', 'true');
            }
            return request.send()
        },

        onUpdateTeamStatus: async (teamId: string, status: number, callback?: () => void) => {
            await API.request('/api/Team/UpdateStatus')
            .endpoint(Endpoints.geograffee)
            .post()
            .body({
                "teamId": teamId,
                "status": status
            })
            .send()
            .then((r) => {
                if (r.status === 200) {
                    callback?.()
                }
            })
        },

        async fetchCompetitionFormData(competitionId: string, mode: 'custom' | 'standard' = 'standard') {
            try {
                const ensureFormResponse = await API.request()
                  .endpoint(Endpoints.geograffee)
                  .url(`/api/forms/competition/${competitionId}/ensure`)
                  .addQuery('mode', mode ?? 'standard')
                  .post()
                  .send();
        
                const formIdFromServer = await ensureFormResponse.json();
        
                const formFieldsResponse = await API.request()
                  .endpoint(Endpoints.geograffee)
                  .url(`/api/forms/Get`)
                  .addQuery('idForm', formIdFromServer)
                  .get()
                  .send();
        
                const formFieldsData = await formFieldsResponse.json();
        
                const filteredFields = formFieldsData?.formFields?.filter((field: any) => field.type !== FormFieldType.LegalDocument) || [];
                const filteredDocs = formFieldsData?.formFields?.filter((field: any) => field.type === FormFieldType.LegalDocument) || [];
                const oldCheckboxes = formFieldsData?.ppdWithCheckMark || [];
                const hasFormFields = Array.isArray(filteredFields) && filteredFields.length > 0

                return {
                    formId: formIdFromServer,
                    fields: filteredFields, 
                    docs: filteredDocs,
                    oldCheckboxes,
                    hasFormFields,
                    header: formFieldsData?.header,
                    description: formFieldsData?.description,
                }
            } catch (error) {
                return {
                    formId: '',
                    fields: [],
                    docs: [],
                    oldCheckboxes: [],
                    hasFormFields: false,
                    header: [],
                    description: [],
                }
            }
        },

        getCompetitionStage(competitionId: string) {
            return API.fetch(
                `https://api.burgdev.ru/competitions/api/Competition/GetCompetitionCurrentStage?competitionId=${competitionId}`,
                {
                    method: 'GET',
                },
            ).then((r) => r.json());
        },

        async fetchTagsTree(props: any, appContext: string) {
            const urls = new URLSearchParams();
            Object.keys(props).forEach((key) => {
                if (props[key] instanceof Array) {
                    for (const val of props[key]) {
                        urls.append(key, val);
                    }
                } else {
                    urls.append(key, props[key]);
                }
            });

            const urlStr = urlSearchParamsToString(urls);
            return await axios.get(`${Endpoints.tagsMnePw}/api/Tags/GetTagsTree?${urlStr}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Application-context': appContext,
                    'Application-name': 'deziiign'
                }
            })
        },

        getLendPresTagsTree(lang: string) {
            return API.request()
                .endpoint(Endpoints.tagsMnePw)
                .url('/api/tags/GetTagsTree')
                .addQuery('entityTypes', 'lend_pres')
                .addQuery('status', 0)
                .addQuery('lang', lang)
                .sendJson();
        },

        getGeoLocation() {
            return MetricsAPI.GetGeoLocation().then((r: any) => r.json())
        },

        getGeoLocationByAccountId({ accountId }: { accountId: string }) {
            return MetricsAPI.GetGeoLocationByAccountId({ accountId }).then((r: any) => r.json())
        },

        async fetchChannelMessages({
            entityId,
            entityType,
            page,
            offset,
            limit,
            parentId
        }: {
            entityId: string,
            entityType: string,
            limit: number,
            offset: number,
            page: number,
            parentId?: RequestParentProps
        }) {
            const params = `entityId=${entityId}${parentId ? `&parentId=${parentId}` : ''}&entityType=${entityType}&limit=${limit}&page=${page}&offset=${offset}`;
            const url = `${Endpoints.message}/api/comment/GetByEntityPaging?${params}`

            return API.fetch(url, {})
                .then((r) => r.json())
                .then(async (messages) => {
                    const { data, paging } = messages;
                    return ({
                        // @ts-ignore
                        data,
                        paging,
                    })
                })
        },

        async fetchFeedTags({
            accountId,
            page,
            limit,
            offset
        }: {
            accountId: string,
            limit: number,
            offset?: number,
            page: number,
        }) {
            const params = `accountId=${accountId}&page=${page}&limit=${limit}&offset=${offset}`;
            const url = `${Endpoints.geograffee}/api/project/GetSubscriptionTagsProjects?${params}`

            return API.fetch(url, {})
                .then((r) => r.json())
                .then(async (messages) => {
                    const { data, paging } = messages;
                    return ({
                        // @ts-ignore
                        data,
                        paging,
                    })
                })
        },

        async fetchSubscriptions({
            subscriberId,
            page,
            offset,
            limit,
            tab,
            isMe,
        }: {
            subscriberId: string,
            page: number,
            offset: number,
            limit: number,
            tab: any,
            isMe: boolean,
        }) {
            const visibilityOpt = `${!isMe ? `&visibility=${SUBSCRIBE_VISIBILITY_STATUS.visible}` : ''}`;
            const subscriberType = '0'
            const targetType = 'userProjects'
            const params = `subscriberId=${subscriberId}&subscriberType=${subscriberType}&targetType=${targetType}&limit=${limit}&page=${page}${visibilityOpt} `
            const url = `${Endpoints.subscriptions}/api/Subscription/GetSubscriptions?${params}`

            return API.fetch(url, {})
                .then((r) => r.json())
                .then(async (subscriptions) => {
                    const { data } = subscriptions;
                    const subsIds = data?.map((i: any) => i?.targetId);

                    if (!subsIds?.length) {
                        return {
                            data: [],
                            paging: [],
                            path: tab.path,
                            entityType: tab.entityType,
                        }
                    }

                    return await DesignerAPI.GetList({
                        designerIds: subsIds,
                        offset: offset,
                        page: page,
                    }).then((r) => r.json())
                        .then((r) => {

                            return ({
                                // @ts-ignore
                                data: mergeArraysBySubscribedId(r?.data, data),
                                paging: r?.paging,
                                path: tab.path,
                                entityType: tab.entityType,
                            })
                        })
                })
        },

        async fetchSubscribers({
            subscriberId,
            page,
            offset,
            limit,
            tab,
        }: {
            subscriberId: string,
            page: number,
            offset: number,
            limit: number,
            tab: any,
        }) {

            const targetType = 'userProjects'
            const params = `targetId=${subscriberId}&targetType=${targetType}&limit=${limit}&page=${page}`
            const url = `${Endpoints.subscriptions}/api/Subscription/GetSubscribers?${params}`

            return API.fetch(url, {})
                .then((r) => r.json())
                .then(async (subscribers) => {
                    const { data } = subscribers;
                    const subsIds = data?.map((i: any) => i?.subscriberId);

                    if (!subsIds?.length) {
                        return {
                            data: [],
                            paging: [],
                            path: tab.path,
                            entityType: tab.entityType,
                        }
                    }

                    return await DesignerAPI.GetList({
                        designerIds: subsIds,
                        offset: offset,
                        page: page,
                    }).then((r) => r.json())
                        .then((r) => {
                            return ({
                                // @ts-ignore
                                data: mergeArraysBySubscribedId(r?.data, data),
                                paging: r?.paging,
                                path: tab.path,
                                entityType: tab.entityType,
                            })
                        })
                })
        },

        fetchOthersUserProjects(projectIds: string[]) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Project/GetListForAuthorIdsAndProjectIds')
                .addQuery('projectIds', projectIds)
                .addQuery('appNameIgnore', 'true')
                .addQuery('isContextIgnored', 'true')
                .addQuery('isLite', 'true')
                .addQuery('onlyAuthors', 'false')
                .sendJson()
        },

        fetchFolders(designerId: string) {
            return API.request()
                .endpoint(Endpoints.folders)
                .url('/api/Folder/GetFoldersByAccId')
                .addQuery('accountId', designerId)
                .sendJson()
        },

        fetchTags(tagIds: string[]) {
            return API.request()
                .endpoint(Endpoints.tagsMnePw)
                .url('/api/Tags/GetTags')
                .addQuery('tagIds', tagIds)
                .sendJson()
        },
        async fetchOwnerChannels(ownerId: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Team/GetList')
                .addQuery('moderationTypes', 7)
                .addQuery('moderationTypes', 8)
                .addQuery('statuses', 0)
                .addQuery('statuses', 2)
                .addQuery('statuses', 3)
                .addQuery('ownerIds', ownerId)
                .sendJson()
                .then((r) => r?.data)
        },
        sendAdmission(payload: any) {
            return API.request()
                .post()
                .endpoint(Endpoints.geograffee)
                .url('/api/forms/SendAdmission')
                .body(payload)
                .sendJson()
        },
        // createNewFeed(teamId: string) {
        //     if (!teamId) return;
        //     return API.request()
        //         .endpoint(Endpoints.geograffee)
        //         .url('api/Team/CreateFeed')
        //         .addQuery('teamId', teamId)
        //         .post()
        //         .sendJson()
        // },
        hasSubscribesOrSubscriptions(designerId: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Designer/GetExistFlagOfSubscriptionOrSubscribers')
                .addQuery('accountId', designerId)
                .sendJson()
        },
        fetchPresentationCover(projectId: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Project/Get')
                .addQuery('idProject', projectId)
                .sendJson()
        },
        getTeamByCourseCardId(cardId: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/LMS/getTeamByCourseCardId')
                .addQuery('cardId', cardId)
                .sendJson()
        },
        getCourseCard(teamId: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/LMS/GetCourseCard')
                .addQuery('teamId', teamId)
                .sendJson()
        },
        async UpdateCards(projectId: string, data: string[]) {
            return await API.fetch(`${Endpoints.geograffee}/api/Project/UpdateCards?projectId=${projectId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
        },
        async UpdateReproductions(projectId: string, data: string[]) {
            return await API.fetch(`${Endpoints.geograffee}/api/Project/UpdateReproductions?projectId=${projectId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
        },

        async UpdateCalendar(projectId: string, data: string[]) {
            return await API.fetch(`${Endpoints.geograffee}/api/Project/UpdateCalendar?projectId=${projectId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
        },

        async UpdateCollection(projectId: string, data: string[]) {
            return await API.fetch(`${Endpoints.geograffee}/api/Project/UpdateCardCollections?projectId=${projectId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
        },

        getUserProducts(queryString: string) {
            return API.fetch(`${cardUrl}/api/Products/GetList?${queryString}`, {}).then(
                (r) => r.json()
            )
        },
        getUser(id: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Designer/Get')
                .addQuery('idDesigner', id)
                .sendJson();
        },


        createNewTag(obj: any) {
            return API.Json(
                TagsAPI.AddTag({
                    ...obj
                })
            ).then((r: any) => r);
        },
        getUserCollectionCards(queryString: string) {
            return API.fetch(`${cardUrl}/api/Card/GetList?${queryString}`, {}).then(
                (r) => r.json()
            )
        },
        getNativeCardById(cardId: string) {
            return API.fetch(`${cardUrl}/api/Card/GetCardOtherTemplate?id=${cardId}&collectionId=places_gallery`, {}).then((r) => r.json())
        },
        checkUserSign(id: string) {
            return API.fetch(`${legalsUrl}/legal/api/UserSign/CheckSignsDocuments?userId=${id}`, {}).then((r) => r?.status === 200 && r.json())
        },
        acceptUserSign(id: string, docId?: string) {
            return API.request()
                .post()
                .endpoint(legalsUrl)
                .url(`/legal/api/UserSign/AcceptSignUser`)
                .body({
                    userId: id,
                    documentIds: [docId]
                })
                .send()
        },

        getCard(id: string) {
            return API.fetch(`${cardUrl}/api/Card/GetCard?id=${id}`, {})
        },

        getBookCard(bookId: string) {
            return API.fetch(`${Endpoints.cardsMnePw}/api/BookCard/GetBookCard?bookId=${bookId}`, {})
        },

        addBookCard(bookId: string, cardIds: string[], chapterIds: string[]) {
            return API.request()
                .post()
                .endpoint(Endpoints.cardsMnePw)
                .url(`api/BookCard/add`)
                .body({
                    chapterIds,
                    cardIds,
                    bookId
                })
                .sendJson()
        },

        copyCard(props: { userId: string, cardId: string, collectionId: string }) {
            return API.fetch(`${cardUrl}/api/Card/CopyCard`, {
                method: 'POST',
                body: JSON.stringify(props),
                response: ResponseType.Text,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
        },

        getCollectionsByUser(query: string, service?: string) {

            return API.request()
                .endpoint(cardUrl)
                .url('/api/Collection/GetArtistCollectionInfo')
                .addQuery('userId', query)
                .addQuery('service', service || 'gallery')
                .sendJson();
        },

        getCollectionsById(query: string) {

            return API.request()
                .endpoint(cardUrl)
                .url('/api/Collection/Get')
                .addQuery('id', query)
                .sendJson();
        },

        createForm(obj: Form) {
            return FormAPI.Add(obj as any)
        },
        getForm(id: string) {
            return FormAPI.Get({ idForm: id })
        },
        deleteLgPost(id: string) {
            return API.request()
                .post()
                .endpoint(Endpoints.longread)
                .url(`/api/post/Delete`)
                .body({
                    postId: id,
                })
                .send()
        },

        getUserCalendars(page: number, profileId: string | undefined, exceptCardId?: string[]) {
            const exceptCardIds = exceptCardId ? exceptCardId.map(x => `exceptCardId=${x}`).join("&") : undefined;
            const url = `${cardUrl}/api/Calendar/GetCalendarsForProject?${profileId ? `accountId=${profileId}&` : ''}page=${page}&limit=${30}${!!exceptCardIds ? `&${exceptCardIds}` : ''}`
            return API.fetch(url, {}).then((r) => r.json())
        },

        getUsedCalendarIds() {
            const url = `${Endpoints.geograffee}/api/Project/GetUsedCalendarIds`
            return API.fetch(url, {}).then((r) => r.json())
        },

        getUsedCollectionsIds() {
            const url = `${Endpoints.geograffee}/api/Project/GetUsedCollections`
            return API.fetch(url, {}).then((r) => r.json())
        },

        saveDesignerList(teamId: string, tagsResponsibilityId: string, designerIds: string[]) {  
            return API.request()
                .post()
                .endpoint(Endpoints.geograffee)
                .url('/api/TeamDesignerList/Save')
                .body({
                    designerIds,
                    teamId,
                    tagsResponsibilityId
                })
                .sendJson()
        },
        getDesignerList(teamId?: string, tagsResponsibilityId?: string, listId?: string) {

            if (!teamId && !tagsResponsibilityId && !listId) {
                return Promise.resolve('List not found')
            }
            
            const request = API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/TeamDesignerList/Get')

            if (teamId) {
                request.addQuery('teamId', teamId)
            }
            if (tagsResponsibilityId) {
                request.addQuery('tagsResponsibilityId', tagsResponsibilityId)
            }

            if (listId) {
                request.addQuery('listId', listId)
            }

            return request.sendJson()
        }
    };
}
import { API, DesignerAPI, Endpoints, Form, FormAPI, MetricsAPI, ResponseType, TagsAPI } from '@brg/api';
import axios from 'axios';
import { RequestParentProps } from 'shared/components/CommentsController/const/types';
import { SUBSCRIBE_VISIBILITY_STATUS } from 'shared/components/Subscribe/const';
import { mergeArraysBySubscribedId } from 'shared/components/Subscribe/support';
import { FormFieldType } from 'shared/modals/ApplicationEditor/constants';
const GETAWAY_DEV = 'api.burgdev.ru';
const GETAWAY_STG = 'api.burgstg.ru';
const GETAWAY_PROD = 'api.mediiia.ru';

interface IGateway {
    [key: string]: string
}

const GATEWAY_ROUTE: IGateway = {
    'develop': GETAWAY_DEV,
    'staging': GETAWAY_STG,
    'production': GETAWAY_PROD
}

const legalsUrl = `https://${GATEWAY_ROUTE[process.env.REACT_APP_API_CONNECTION_MODE as keyof IGateway]}`
const cardUrl = Endpoints.cardsMnePw;

export const getGalllleryUrl = (isShop: boolean) => {
    const galleryUrls = {
        develop: 'https://gallllery-com.burgdev.ru',
        staging: 'https://gallllery-com.burgstg.ru',
        production: 'https://gallllery.com',
        hseOnline: 'https://gallllery.com'
    }

    const shopGalleryUrls = {
        develop: 'https://shop-artz-work.burgdev.ru',
        staging: 'https://shop-artz-work.burgstg.ru',
        production: 'https://shop.artz.work',
        hseOnline: 'https://shop.artz.work'
    }

    // @ts-ignore
    return (isShop ? shopGalleryUrls : galleryUrls)[process.env.REACT_APP_API_CONNECTION_MODE ?? 'develop'];
}

const urlSearchParamsToString = (params: any) => {
    const paramArray = [];
    //@ts-ignore
    for (const [key, value] of params.entries()) {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(value);
        paramArray.push(`${encodedKey}=${encodedValue}`);
    }

    if (paramArray.length === 0) {
        return '';
    }

    return `&${paramArray.join('&')}`;
}


export default function urlApi() {
    return {
        applyProjectToCompetition({ nominationId, projectId, makePrivate }: { nominationId: string, projectId: string, makePrivate?: boolean }) {
            const request = API.request()
                .endpoint(Endpoints.competitions)
                .url('/api/Competition/Apply')
                .post()
                .addQuery('NominationID', nominationId)
                .addQuery('ProjectID', projectId)
            if (makePrivate) {
                request.addQuery('hideProject', 'true');
            }
            return request.send()
        },

        onUpdateTeamStatus: async (teamId: string, status: number, callback?: () => void) => {
            await API.request('/api/Team/UpdateStatus')
            .endpoint(Endpoints.geograffee)
            .post()
            .body({
                "teamId": teamId,
                "status": status
            })
            .send()
            .then((r) => {
                if (r.status === 200) {
                    callback?.()
                }
            })
        },

        async fetchCompetitionFormData(competitionId: string, mode: 'custom' | 'standard' = 'standard') {
            try {
                const ensureFormResponse = await API.request()
                  .endpoint(Endpoints.geograffee)
                  .url(`/api/forms/competition/${competitionId}/ensure`)
                  .addQuery('mode', mode ?? 'standard')
                  .post()
                  .send();
        
                const formIdFromServer = await ensureFormResponse.json();
        
                const formFieldsResponse = await API.request()
                  .endpoint(Endpoints.geograffee)
                  .url(`/api/forms/Get`)
                  .addQuery('idForm', formIdFromServer)
                  .get()
                  .send();
        
                const formFieldsData = await formFieldsResponse.json();
        
                const filteredFields = formFieldsData?.formFields?.filter((field: any) => field.type !== FormFieldType.LegalDocument) || [];
                const filteredDocs = formFieldsData?.formFields?.filter((field: any) => field.type === FormFieldType.LegalDocument) || [];
                const oldCheckboxes = formFieldsData?.ppdWithCheckMark || [];
                const hasFormFields = Array.isArray(filteredFields) && filteredFields.length > 0

                return {
                    formId: formIdFromServer,
                    fields: filteredFields, 
                    docs: filteredDocs,
                    oldCheckboxes,
                    hasFormFields,
                    header: formFieldsData?.header,
                    description: formFieldsData?.description,
                }
            } catch (error) {
                return {
                    formId: '',
                    fields: [],
                    docs: [],
                    oldCheckboxes: [],
                    hasFormFields: false,
                    header: [],
                    description: [],
                }
            }
        },

        getCompetitionStage(competitionId: string) {
            return API.fetch(
                `https://api.burgdev.ru/competitions/api/Competition/GetCompetitionCurrentStage?competitionId=${competitionId}`,
                {
                    method: 'GET',
                },
            ).then((r) => r.json());
        },

        async fetchTagsTree(props: any, appContext: string) {
            const urls = new URLSearchParams();
            Object.keys(props).forEach((key) => {
                if (props[key] instanceof Array) {
                    for (const val of props[key]) {
                        urls.append(key, val);
                    }
                } else {
                    urls.append(key, props[key]);
                }
            });

            const urlStr = urlSearchParamsToString(urls);
            return await axios.get(`${Endpoints.tagsMnePw}/api/Tags/GetTagsTree?${urlStr}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Application-context': appContext,
                    'Application-name': 'deziiign'
                }
            })
        },

        getLendPresTagsTree(lang: string) {
            return API.request()
                .endpoint(Endpoints.tagsMnePw)
                .url('/api/tags/GetTagsTree')
                .addQuery('entityTypes', 'lend_pres')
                .addQuery('status', 0)
                .addQuery('lang', lang)
                .sendJson();
        },

        getGeoLocation() {
            return MetricsAPI.GetGeoLocation().then((r: any) => r.json())
        },

        getGeoLocationByAccountId({ accountId }: { accountId: string }) {
            return MetricsAPI.GetGeoLocationByAccountId({ accountId }).then((r: any) => r.json())
        },

        async fetchChannelMessages({
            entityId,
            entityType,
            page,
            offset,
            limit,
            parentId
        }: {
            entityId: string,
            entityType: string,
            limit: number,
            offset: number,
            page: number,
            parentId?: RequestParentProps
        }) {
            const params = `entityId=${entityId}${parentId ? `&parentId=${parentId}` : ''}&entityType=${entityType}&limit=${limit}&page=${page}&offset=${offset}`;
            const url = `${Endpoints.message}/api/comment/GetByEntityPaging?${params}`

            return API.fetch(url, {})
                .then((r) => r.json())
                .then(async (messages) => {
                    const { data, paging } = messages;
                    return ({
                        // @ts-ignore
                        data,
                        paging,
                    })
                })
        },

        async fetchFeedTags({
            accountId,
            page,
            limit,
            offset
        }: {
            accountId: string,
            limit: number,
            offset?: number,
            page: number,
        }) {
            const params = `accountId=${accountId}&page=${page}&limit=${limit}&offset=${offset}`;
            const url = `${Endpoints.geograffee}/api/project/GetSubscriptionTagsProjects?${params}`

            return API.fetch(url, {})
                .then((r) => r.json())
                .then(async (messages) => {
                    const { data, paging } = messages;
                    return ({
                        // @ts-ignore
                        data,
                        paging,
                    })
                })
        },

        async fetchSubscriptions({
            subscriberId,
            page,
            offset,
            limit,
            tab,
            isMe,
        }: {
            subscriberId: string,
            page: number,
            offset: number,
            limit: number,
            tab: any,
            isMe: boolean,
        }) {
            const visibilityOpt = `${!isMe ? `&visibility=${SUBSCRIBE_VISIBILITY_STATUS.visible}` : ''}`;
            const subscriberType = '0'
            const targetType = 'userProjects'
            const params = `subscriberId=${subscriberId}&subscriberType=${subscriberType}&targetType=${targetType}&limit=${limit}&page=${page}${visibilityOpt} `
            const url = `${Endpoints.subscriptions}/api/Subscription/GetSubscriptions?${params}`

            return API.fetch(url, {})
                .then((r) => r.json())
                .then(async (subscriptions) => {
                    const { data } = subscriptions;
                    const subsIds = data?.map((i: any) => i?.targetId);

                    if (!subsIds?.length) {
                        return {
                            data: [],
                            paging: [],
                            path: tab.path,
                            entityType: tab.entityType,
                        }
                    }

                    return await DesignerAPI.GetList({
                        designerIds: subsIds,
                        offset: offset,
                        page: page,
                    }).then((r) => r.json())
                        .then((r) => {

                            return ({
                                // @ts-ignore
                                data: mergeArraysBySubscribedId(r?.data, data),
                                paging: r?.paging,
                                path: tab.path,
                                entityType: tab.entityType,
                            })
                        })
                })
        },

        async fetchSubscribers({
            subscriberId,
            page,
            offset,
            limit,
            tab,
        }: {
            subscriberId: string,
            page: number,
            offset: number,
            limit: number,
            tab: any,
        }) {

            const targetType = 'userProjects'
            const params = `targetId=${subscriberId}&targetType=${targetType}&limit=${limit}&page=${page}`
            const url = `${Endpoints.subscriptions}/api/Subscription/GetSubscribers?${params}`

            return API.fetch(url, {})
                .then((r) => r.json())
                .then(async (subscribers) => {
                    const { data } = subscribers;
                    const subsIds = data?.map((i: any) => i?.subscriberId);

                    if (!subsIds?.length) {
                        return {
                            data: [],
                            paging: [],
                            path: tab.path,
                            entityType: tab.entityType,
                        }
                    }

                    return await DesignerAPI.GetList({
                        designerIds: subsIds,
                        offset: offset,
                        page: page,
                    }).then((r) => r.json())
                        .then((r) => {
                            return ({
                                // @ts-ignore
                                data: mergeArraysBySubscribedId(r?.data, data),
                                paging: r?.paging,
                                path: tab.path,
                                entityType: tab.entityType,
                            })
                        })
                })
        },

        fetchOthersUserProjects(projectIds: string[]) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Project/GetListForAuthorIdsAndProjectIds')
                .addQuery('projectIds', projectIds)
                .addQuery('appNameIgnore', 'true')
                .addQuery('isContextIgnored', 'true')
                .addQuery('isLite', 'true')
                .addQuery('onlyAuthors', 'false')
                .sendJson()
        },

        fetchFolders(designerId: string) {
            return API.request()
                .endpoint(Endpoints.folders)
                .url('/api/Folder/GetFoldersByAccId')
                .addQuery('accountId', designerId)
                .sendJson()
        },

        fetchTags(tagIds: string[]) {
            return API.request()
                .endpoint(Endpoints.tagsMnePw)
                .url('/api/Tags/GetTags')
                .addQuery('tagIds', tagIds)
                .sendJson()
        },
        async fetchOwnerChannels(ownerId: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Team/GetList')
                .addQuery('moderationTypes', 7)
                .addQuery('moderationTypes', 8)
                .addQuery('statuses', 0)
                .addQuery('statuses', 2)
                .addQuery('statuses', 3)
                .addQuery('ownerIds', ownerId)
                .sendJson()
                .then((r) => r?.data)
        },
        sendAdmission(payload: any) {
            return API.request()
                .post()
                .endpoint(Endpoints.geograffee)
                .url('/api/forms/SendAdmission')
                .body(payload)
                .sendJson()
        },
        // createNewFeed(teamId: string) {
        //     if (!teamId) return;
        //     return API.request()
        //         .endpoint(Endpoints.geograffee)
        //         .url('api/Team/CreateFeed')
        //         .addQuery('teamId', teamId)
        //         .post()
        //         .sendJson()
        // },
        hasSubscribesOrSubscriptions(designerId: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Designer/GetExistFlagOfSubscriptionOrSubscribers')
                .addQuery('accountId', designerId)
                .sendJson()
        },
        fetchPresentationCover(projectId: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Project/Get')
                .addQuery('idProject', projectId)
                .sendJson()
        },
        getTeamByCourseCardId(cardId: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/LMS/getTeamByCourseCardId')
                .addQuery('cardId', cardId)
                .sendJson()
        },
        getCourseCard(teamId: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/LMS/GetCourseCard')
                .addQuery('teamId', teamId)
                .sendJson()
        },
        async UpdateCards(projectId: string, data: string[]) {
            return await API.fetch(`${Endpoints.geograffee}/api/Project/UpdateCards?projectId=${projectId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
        },
        async UpdateReproductions(projectId: string, data: string[]) {
            return await API.fetch(`${Endpoints.geograffee}/api/Project/UpdateReproductions?projectId=${projectId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
        },

        async UpdateCalendar(projectId: string, data: string[]) {
            return await API.fetch(`${Endpoints.geograffee}/api/Project/UpdateCalendar?projectId=${projectId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
        },

        async UpdateCollection(projectId: string, data: string[]) {
            return await API.fetch(`${Endpoints.geograffee}/api/Project/UpdateCardCollections?projectId=${projectId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
        },

        getUserProducts(queryString: string) {
            return API.fetch(`${cardUrl}/api/Products/GetList?${queryString}`, {}).then(
                (r) => r.json()
            )
        },
        getUser(id: string) {
            return API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Designer/Get')
                .addQuery('idDesigner', id)
                .sendJson();
        },


        createNewTag(obj: any) {
            return API.Json(
                TagsAPI.AddTag({
                    ...obj
                })
            ).then((r: any) => r);
        },
        getUserCollectionCards(queryString: string) {
            return API.fetch(`${cardUrl}/api/Card/GetList?${queryString}`, {}).then(
                (r) => r.json()
            )
        },
        getNativeCardById(cardId: string) {
            return API.fetch(`${cardUrl}/api/Card/GetCardOtherTemplate?id=${cardId}&collectionId=places_gallery`, {}).then((r) => r.json())
        },
        checkUserSign(id: string) {
            return API.fetch(`${legalsUrl}/legal/api/UserSign/CheckSignsDocuments?userId=${id}`, {}).then((r) => r?.status === 200 && r.json())
        },
        acceptUserSign(id: string, docId?: string) {
            return API.request()
                .post()
                .endpoint(legalsUrl)
                .url(`/legal/api/UserSign/AcceptSignUser`)
                .body({
                    userId: id,
                    documentIds: [docId]
                })
                .send()
        },

        getCard(id: string) {
            return API.fetch(`${cardUrl}/api/Card/GetCard?id=${id}`, {})
        },

        getBookCard(bookId: string) {
            return API.fetch(`${Endpoints.cardsMnePw}/api/BookCard/GetBookCard?bookId=${bookId}`, {})
        },

        addBookCard(bookId: string, cardIds: string[], chapterIds: string[]) {
            return API.request()
                .post()
                .endpoint(Endpoints.cardsMnePw)
                .url(`api/BookCard/add`)
                .body({
                    chapterIds,
                    cardIds,
                    bookId
                })
                .sendJson()
        },

        copyCard(props: { userId: string, cardId: string, collectionId: string }) {
            return API.fetch(`${cardUrl}/api/Card/CopyCard`, {
                method: 'POST',
                body: JSON.stringify(props),
                response: ResponseType.Text,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
        },

        getCollectionsByUser(query: string, service?: string) {

            return API.request()
                .endpoint(cardUrl)
                .url('/api/Collection/GetArtistCollectionInfo')
                .addQuery('userId', query)
                .addQuery('service', service || 'gallery')
                .sendJson();
        },

        getCollectionsById(query: string) {

            return API.request()
                .endpoint(cardUrl)
                .url('/api/Collection/Get')
                .addQuery('id', query)
                .sendJson();
        },

        createForm(obj: Form) {
            return FormAPI.Add(obj as any)
        },
        getForm(id: string) {
            return FormAPI.Get({ idForm: id })
        },
        deleteLgPost(id: string) {
            return API.request()
                .post()
                .endpoint(Endpoints.longread)
                .url(`/api/post/Delete`)
                .body({
                    postId: id,
                })
                .send()
        },

        getUserCalendars(page: number, profileId: string | undefined, exceptCardId?: string[]) {
            const exceptCardIds = exceptCardId ? exceptCardId.map(x => `exceptCardId=${x}`).join("&") : undefined;
            const url = `${cardUrl}/api/Calendar/GetCalendarsForProject?${profileId ? `accountId=${profileId}&` : ''}page=${page}&limit=${30}${!!exceptCardIds ? `&${exceptCardIds}` : ''}`
            return API.fetch(url, {}).then((r) => r.json())
        },

        getUsedCalendarIds() {
            const url = `${Endpoints.geograffee}/api/Project/GetUsedCalendarIds`
            return API.fetch(url, {}).then((r) => r.json())
        },

        getUsedCollectionsIds() {
            const url = `${Endpoints.geograffee}/api/Project/GetUsedCollections`
            return API.fetch(url, {}).then((r) => r.json())
        },

        saveDesignerList(teamId: string, tagsResponsibilityId: string, designerIds: string[]) {  
            return API.request()
                .post()
                .endpoint(Endpoints.geograffee)
                .url('/api/TeamDesignerList/Save')
                .body({
                    designerIds,
                    teamId,
                    tagsResponsibilityId
                })
                .sendJson()
        },
        getDesignerList(teamId?: string, tagsResponsibilityId?: string, listId?: string) {

            if (!teamId && !tagsResponsibilityId && !listId) {
                return Promise.resolve('List not found')
            }
            
            const request = API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/TeamDesignerList/Get')

            if (teamId) {
                request.addQuery('teamId', teamId)
            }
            if (tagsResponsibilityId) {
                request.addQuery('tagsResponsibilityId', tagsResponsibilityId)
            }

            if (listId) {
                request.addQuery('listId', listId)
            }

            return request.sendJson()
        }
    };
}
